import React, { useState } from "react";
import { Button, Modal } from "antd";
import UploadExcel from "./UploadExcel";
import { ModalProps } from "antd/lib/modal";

interface UploadModalProps extends ModalProps {
    onUploadOk: (file: File | undefined) => void; //上传文件的回调
    onCancel: () => void; //取消上传或关闭弹窗
    children?: React.ReactNode;
    tips?: React.ReactNode;
}
export default function UploadModal({
    onUploadOk,
    onCancel,
    children,
    tips,
    ...restProps
}: UploadModalProps) {
    const [file, setFile] = useState<File>(); //上传的文件

    function uploadOk() {
        onUploadOk(file);
    }

    //点击删除文件
    function onDeleteFile() {
        setFile(undefined);
    }

    const footer = (
        <div>
            <Button key="back" onClick={() => onCancel()}>
                取消
            </Button>
            <Button
                key="submit"
                onClick={() => uploadOk()}
                type={"primary"}
                disabled={!file}>
                确认
            </Button>
        </div>
    );

    return (
        <Modal
            width={610}
            maskClosable={false}
            onCancel={onCancel}
            {...restProps}
            footer={footer}>
            {children}

            <UploadExcel onDeleteFile={onDeleteFile} setFile={setFile} />

            {tips}
        </Modal>
    );
}
